import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-curve-shape-narrow-swoosh",
  "use": "icon-curve-shape-narrow-swoosh-usage",
  "viewBox": "0 0 771.5 30.26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 771.5 30.26\" preserveAspectRatio=\"none\" id=\"icon-curve-shape-narrow-swoosh\"><path d=\"M771.5 18v12.26H0v-6.81c3.47-.24 84.73-7.11 166.2-9.49 55.5-1.63 96.4-.65 96.4-.65s-22.51-4.5-98.5-5C98.2 7.87 3.79 13.83 0 14V3.38s86.4-5.79 203.35-2.21S453 27 579.31 25.75C715 24.36 771.5 18 771.5 18zm0-16.81v11.5c-34.55 2.54-99.71 6.68-164 7.19-133.28 1-262.84-14.55-262.84-14.55s117.8 7.54 264.44 4c76.26-1.92 132.3-5.7 162.4-8.14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol